import type {Connection} from './api';
export function needsInvitation(connection:Connection):boolean {
 const host=new URL(connection.baseUrl).hostname;
 return !['localhost','127.0.0.1','[::1]'].includes(host)&&(!connection.game||!connection.token);
}
export function connectEvents(connection:Connection,onChange:(event:{type:string;periodIndex:number;extended?:boolean;reason?:string;deadlineAt?:number|null})=>void,onStatus:(status:string)=>void,Source:typeof EventSource=EventSource):()=>void {
 const url=new URL(connection.baseUrl.replace(/\/$/,'')+'/api/events');
 if(connection.game)url.searchParams.set('game',connection.game);
 if(connection.token)url.searchParams.set('token',connection.token);
 let source:EventSource;
 try{source=new Source(url.href);}catch{onStatus('Автообновление недоступно. Используйте «Обновить».');return ()=>{};}
 source.onopen=()=>onStatus('Живые обновления подключены');
 source.onerror=()=>onStatus('Поток событий недоступен. Можно продолжать игру и обновлять данные вручную.');
 source.onmessage=e=>{try{const ev=JSON.parse(e.data);if(['hello','turn','period','deadline'].includes(ev.type)&&Number.isInteger(ev.periodIndex)&&ev.periodIndex>=0)onChange(ev);}catch{/* Ignore malformed events, never replace authoritative state. */}};
 return ()=>source.close();
}
